import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryEvents = createBaseQuery('events');
const baseQueryMedia = createBaseQuery('media');

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const { url } = args;
  const selectedBaseQuery =
    url === '/upload-public-flyer' || url.startsWith('/delete-public-event')
      ? baseQueryMedia
      : baseQueryEvents;

  return selectedBaseQuery(args, api, extraOptions);
};

export const eventApiSlice = createApi({
  reducerPath: 'eventApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    uploadPublicFlyer: builder.mutation({
      query: (formData) => ({
        url: `/upload-public-flyer`,
        method: 'POST',
        body: formData
      })
    }),
    submitPublicEvent: builder.mutation({
      query: (eventData) => ({
        url: `/submit-public-event`,
        method: 'POST',
        body: eventData
      }),
      invalidatesTags: ['Events']
    }),

    getAllPublicEvents: builder.query({
      query: (params) => ({
        url: `/get-public-events`,
        method: 'POST',
        body: params
      }),
      providesTags: ['Events']
    }),
    deletePublicEvent: builder.mutation({
      query: (eventId) => ({
        url: `/delete-public-event?id=${eventId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Events']
    }),
    registerForPublicEvent: builder.mutation({
      query: (registrationData) => ({
        url: `/public-event/register`,
        method: 'POST',
        body: registrationData
      })
    }),
    getAllRegisteredUsers: builder.query({
      query: (eventId) => ({
        url: `/public-event/users`,
        method: 'POST',
        body: { event_id: eventId }
      }),
      keepUnusedDataFor: 0
    }),
    updatePublicEventTitle: builder.mutation({
      query: (updateData) => ({
        url: `/update-public-event`,
        method: 'PUT',
        body: updateData
      }),
      invalidatesTags: ['Events']
    }),
    updatePublicEventWithFlyer: builder.mutation({
      query: (formData) => ({
        url: `/update-public-event`,
        method: 'PUT',
        body: formData
      }),
      invalidatesTags: ['Events']
    })
  })
});

export const {
  useGetAllPublicEventsQuery,
  useUploadPublicFlyerMutation,
  useSubmitPublicEventMutation,
  useDeletePublicEventMutation,
  useLazyGetAllRegisteredUsersQuery,
  useUpdatePublicEventTitleMutation,
  useRegisterForPublicEventMutation,
  useUpdatePublicEventWithFlyerMutation
} = eventApiSlice;
